<template>
  <div>
    <div class="pa-6 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Hồ sơ Ban Giám Hiệu"
          :link="[
            {
              text: 'Hồ sơ',
              href: '../managerDocumentTypes'
            }
          ]"
        />
      </div>
    </div>
    <v-card class="ma-6 pa-6 mt-0" outlined>
      <DocumentTypeFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card outlined class="mx-6 elevation-0">
      <div class="pa-6 d-flex justify-space-between align-center" v-if="isEditDocument">
        <v-spacer />
        <v-btn depressed dark color="primary" @click.stop="dialog = true"> Thêm mục </v-btn>
      </div>
      <DocumentTypeDataTable :type="'manager-document'" ref="docTypeTable" :schoolYear="schoolYear" />
    </v-card>

    <v-dialog v-model="dialog" scrollable width="700">
      <v-card>
        <v-toolbar color="primary" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm mục</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="title"
              :rules="[$rules.required]"
              label="Tên mục"
              class="required mt-6"
              outlined
              dense
            ></v-text-field>
            <v-textarea v-model="description" label="Mô tả" outlined></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn outlined @click="cancel">HUỶ</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">LƯU</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DocumentTypeDataTable from '@/modules/document/DocumentTypeDataTable.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import DocumentTypeFilter from '../../modules/document/DocumentTypeFilter.vue'
import { get } from 'lodash'

export default {
  components: {
    Breadcrumbs,
    DocumentTypeDataTable,
    DocumentTypeFilter
  },
  props: {},
  data() {
    return {
      dialog: false,
      description: '',
      title: '',
      schoolYear: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument']),
    ...mapState('DocumentTypes', ['documentTypes'])
  },
  methods: {
    ...mapActions('DocumentTypes', ['createDocumentType']),
    cancel() {
      this.dialog = false
    },
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true

        const data = {
          type: 'manager-document',
          title: this.title,
          description: this.description,
          schoolYear: this.schoolYear
        }
        await this.createDocumentType(data)

        this.$refs.form.reset()
        this.dialog = false
        this.$alert.addSuccess()
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    onFilterChanged(data) {
      if (get(data, 'schoolYear')) {
        this.schoolYear = get(data, 'schoolYear', null)
      }
      this.$refs.docTypeTable.refresh(data)
    }
  }
}
</script>
